import {useOktaAuth} from '@okta/okta-react';
import {Constants} from '../Constants';
import {useEffect, useState} from 'react';

export const BulkLoadUserCheck = (): boolean => {
    const {authState} = useOktaAuth();
    const claims = authState?.idToken?.claims;
    const userAdGroups = claims ? JSON.parse(JSON.stringify(claims)).jduAdminAdGroups : [];

    return userAdGroups ? userAdGroups.some((v: string) => Constants.BULK_CLASS_ACCESS_GROUPS.includes(v)) : false;
};

export const BillingUserCheck = (): boolean => {
    const {authState} = useOktaAuth();
    const claims = authState?.idToken?.claims;

    const userAdGroups = claims ? ((): any => {
        const copiedClaims = JSON.parse(JSON.stringify(claims));
        const adminGroups: string[] = copiedClaims.jduAdminAdGroups || [];
        const adGroups: string[] = copiedClaims.jduadgroups || [];

        return [...adminGroups, ...adGroups];
    })() : [];

    return userAdGroups ? userAdGroups.some((v: string) => Constants.JDU_BILLING_ACCESS_GROUPS.includes(v)) : false;
};

export const AdminReqUserCheck = (): boolean => {
    const {authState} = useOktaAuth();
    const [adminRequestAccess, setAdminRequestAccess] = useState(false);

    useEffect(() => {
        if (authState) {
            fetch(`${process.env.REACT_APP_BACKEND_URL}/adminrequestaccess`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authState.accessToken?.accessToken}`,
                    'Content-Type': 'application/json'
                }
            }).then((res) => {
                return res.json();
            }).then((data) => {
                setAdminRequestAccess(data);
                return data;
            }).catch((error) => console.log(error));
        }
    }, [authState]);

    return adminRequestAccess;
};

export const ScheduledClassesUserCheck = (): boolean => {
    const {authState} = useOktaAuth();
    const [scheculedClassesAccess, setScheculedClassesAccess] = useState(false);

    useEffect(() => {
        if (authState) {
            fetch(`${process.env.REACT_APP_BACKEND_URL}/scheduledClassesPermission`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authState.accessToken?.accessToken}`,
                    'Content-Type': 'application/json'
                }
            }).then((res) => {
                return res.json();
            }).then((data) => {
                setScheculedClassesAccess(data);
                return data;
            }).catch((error) => console.log(error));
        }
    }, [authState]);

    return scheculedClassesAccess;
};
